export default __webpack_public_path__ + "static/Logotyp-e1314e8197801d4db399fe8796344b94.svg";